// removed by extract-text-webpack-plugin
module.exports = {"component":"_3RZyT9hAZ978ZqVQQFhzDA","header":"_216x0mxu0j9DCI1gwyC7v9","firstFullPageItem":"yNSWzUy3AneC3BTvqOfg-","goeasySection":"_2wRNZjTEC2XVDs6hyR30rj","nextIcon":"_3dlrl-DBu8DXssoPPoa4TJ","xiala":"_1CeqxaFJ7_Ju_rkdQIYAiT","buyBtn":"_2QZUHk1JkwURQl_iq6aA6a","traioef_an":"_32PQjfkVn8KZIu-9hHP2sF"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Intro/Intro.scss
 ** module id = 1069
 ** module chunks = 0
 **/